export const DIAMOND_PILL_CLASS = "rounded-full border border-violet-500/35 bg-violet-500/[0.14] px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.06em] text-violet-300";
